import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { stripPrerenderedSeoTags } from "@/utils/seoHeadDedupe";
import { initMetaPixel } from "@/utils/metaPixel";
import { initGoogleTags } from "@/utils/googleTags";
import { initConsentCounter } from "@/utils/firstPartyAnalytics";
import { maybeStartVisit } from "@/utils/nyHemsidaVisit";

// Prerender-pipelinen (scripts/prerender-seo.js) märker de fyra
// route-specifika SEO-taggarna (title, description, robots, canonical)
// med `data-prerendered-seo="1"` så att crawlers utan JS ser komplett
// SEO i raw HTML. Här tas EXAKT de märkta kopiorna bort — synkront,
// innan React mountar — så att React/Helmet blir ensam ägare av dessa
// taggar efter hydrering (1 title / 1 description / 1 robots /
// 1 canonical). OG/Twitter/JSON-LD/GTM rörs inte.
stripPrerenderedSeoTags();

// Starta förstaparts-observability-besöket TIDIGT (före Meta/GA-init) så att
// stored-consent + Meta/GA-start kan knytas till samma /ny-hemsida-besök.
// Ren diagnostik: kortlivat pseudonymt visit_id i JS-minne — ingen lagring.
maybeStartVisit();

// Meta Pixel — laddas consent-gated (init + PageView först efter godkänt
// marknadsföringssamtycke; direkt vid sidladdning om redan godkänt).
initMetaPixel();

// Google tags (GA4 + Google Ads) — BASIC Consent Mode. gtag.js laddas först
// efter samtycke (statistics → GA4, marketing → Ads). Vid "Neka alla" laddas
// inget och ingen trackingdata skickas till Google.
initGoogleTags();

// Anonym aggregerad consent-räknare (marketing_granted/denied). Ökas när
// cookie-komponenten sparar ett aktivt beslut. Ingen PII, ingen identifiering.
initConsentCounter();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
